import * as React from "react";
const SvgReorderThreeOutlineinline = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", viewBox: "0 0 512 512", ...props }, /* @__PURE__ */ React.createElement("title", null, "ionicons-v5-p"), /* @__PURE__ */ React.createElement("line", { x1: 96, y1: 256, x2: 416, y2: 256, style: {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 32
} }), /* @__PURE__ */ React.createElement("line", { x1: 96, y1: 176, x2: 416, y2: 176, style: {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 32
} }), /* @__PURE__ */ React.createElement("line", { x1: 96, y1: 336, x2: 416, y2: 336, style: {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 32
} }));
export default SvgReorderThreeOutlineinline;
